import { render, staticRenderFns } from "./AnnouncementTargetControl.vue?vue&type=template&id=f4dbd4c2&scoped=true"
import script from "./AnnouncementTargetControl.vue?vue&type=script&lang=js"
export * from "./AnnouncementTargetControl.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementTargetControl.vue?vue&type=style&index=0&id=f4dbd4c2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dbd4c2",
  null
  
)

export default component.exports